var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xt-hover"},[_c('div',{staticClass:"xt-hover-content"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"xt-hover-suspension",class:'xt-hover-suspension-transform-' + _vm.animation},[_vm._t("hover")],2)],2),_vm._v(" "),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }